import { Actions, ActionTypes } from '../actions/loading-state.actions';
import { initialState, PatientDataState } from '../state';
import { ActionReducer, MetaReducer } from '@ngrx/store';
import { CORE_ACTIONS } from '@ispm/core/constants/core-actions.constant';


export function patientDataReducer(state = initialState, action: Actions): PatientDataState {
  switch (action.type) {
    case ActionTypes.FETCH_PATIENT_DATA:
      return {
        ...state
      };
    case ActionTypes.UPDATE_PATIENT_DATA:
      return {
        ...state,
        patient: action.payload.patientData
      };
    case ActionTypes.SET_ERROR:
      return {
        ...state,
        error: action.payload.error
      };
    default: {
      return state;
    }
  }
}

export function clearStateReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  return function (state, action: any) {
    if (action.type === CORE_ACTIONS.CLEAR_ALL_CACHED_ITEMS) {
      return initialState;
    }

    return reducer(state, action);
  };
}

export const metaReducers: MetaReducer<any>[] = [clearStateReducer];
